import styled from "styled-components/macro";

export const StyledLogContainer = styled.div`
  width: 100%;
  margin-right: 7px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: 420px;
  margin: 20px 0;
  align-items: center;
  .header {
    margin-bottom: 17px;

    .title {
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      h3 {
        margin-bottom: 5px !important;
      }

      .close {
        font-size: 12px;
        color: var(--grey-2);
      }
    }

    .subtitle {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: var(--grey-2);
      text-align: left;

      svg {
        width: 17px;
        path {
          fill: var(--grey-2);
        }
      }
    }
  }

  .log {
    width: 100%;
    min-height: 235px;
    margin-bottom: 20px;
    flex: 1 1 auto;
    max-height: 320px;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .toggle-setting {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    label {
      font-size: 16px;
      margin-right: 10px;
    }

    .switch {
      //this css is duplicated in the guidance styles, consider componentizing or backing out to root
      position: relative;
      display: block;
      width: 40px;
      height: 20px;

      input {
        opacity: 0;
        width: 0;
        height: 0;
      }

      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--menu-color-active);
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }

      .slider:before {
        position: absolute;
        content: "";
        height: 22px;
        width: 22px;
        left: -1px;
        bottom: -1px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
      }

      input:checked + .slider {
        background-color: var(--primary-cta-high-contrast);
      }

      input:checked + .slider:before {
        -webkit-transform: translateX(20px);
        -ms-transform: translateX(20px);
        transform: translateX(20px);
        background-color: white;
      }

      .slider.round {
        border-radius: 34px;
      }

      .slider.round:before {
        border-radius: 50%;
      }
    }
  }
`;

export const StyledEntryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 13px;

  .entry {
    width: 100%;

    .entry-wrapper {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }

  .entry-title {
    color: var(--grey-0);
    text-align: left;

    .entry-label-with-toggle {
      display: flex;
      align-items: center;

      .chat-group-toggle,
      .chevron-placeholder {
        width: 18px;
        height: 18px;
        min-width: 18px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
      }

      .chevron-placeholder {
        opacity: 0;
      }

      .chat-group-toggle {
        border: none;
        background: transparent;
        cursor: pointer;
        padding: 0 !important;

        &::before {
          border-radius: 2px !important;
        }

        &:hover::before,
        &:focus-visible::before {
          border-radius: 2px !important;
        }

        .chevron-icon {
          width: 14px;
          height: 14px;
          transition: transform 0.15s ease;
          display: inline-flex;

          path {
            fill: var(--grey-1);
          }
        }

        &.expanded .chevron-icon {
          transform: rotate(180deg);
        }

        &.agentic .chevron-icon {
          transform: rotate(-90deg);
        }

        &.agentic.expanded .chevron-icon {
          transform: rotate(0deg);
        }
      }
    }

    .main-label {
      font-size: 14px;
      line-height: 124.2%;
    }

    .sub-label {
      font-size: 10px;
      line-height: 124.2%;
      // margin-top: 2px;
    }
  }

  .entry-amount {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: "IBM Plex Mono", monospace;
    font-weight: 400;
    line-height: 124.2%;
    color: var(--grey-0);
    letter-spacing: 0.84px;

    svg {
      width: 17px;
      margin-left: 5px;
      path {
        fill: var(--grey-1);
      }
    }
  }
`;
